
import { ExportReports } from "../ApiEndPoints";
import { axiosPostFileAuthorizeblob } from "../AxiosRequests";

export default class ReportServices {
    async ExportReports(request) {
        return axiosPostFileAuthorizeblob(ExportReports, request);
    }
}